import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthed, getRole } from './api';

// Gate an admin route. Redirects to /admin/login if not authed,
// or to the user's own dashboard if they hit the wrong panel.
// The webmaster is a super-admin and may view any panel (e.g. "view as manager").
const RequireRole = ({ role, children }) => {
  if (!isAuthed()) return <Navigate to="/portal/login" replace />;
  const current = getRole();
  // Webmaster is super-admin (may view any panel). The demo/review account
  // acts as a manager. Everyone else must match the panel's role.
  const allowed = current === role || current === 'webmaster' || (role === 'manager' && current === 'demo');
  if (!allowed) {
    return <Navigate to={current === 'webmaster' ? '/portal/webmaster' : '/portal/manager'} replace />;
  }
  return children;
};

export default RequireRole;
